/**
 * Design System - Dimension Tokens
 *
 * Fixed dimensions used in the design
 */

export const dimensions = {
  // Container widths
  container: {
    hero: '720px',
    experienceList: '1087px',
    experienceListInner: '1073px',
    headerWide: '744px',
    headerMedium: '556px',
    leftPanel: '430px',
    maxContent: '1407px',
    maxContentAlt: '1400px',
    maxContentSmall: '1394px',
    maxContentMedium: '1401px',
    chat: '720px',
    placeOverlay: '618px',
  },

  // Component sizes
  component: {
    // Card dimensions
    cardSignature: {
      width: '286px',
      height: '536px',
    },
    cardExperience: {
      width: '180px',
      height: '160px',
    },
    cardPackage: {
      imageHeight: '215px',
    },
    cardBoutique: {
      height: '548px',
    },
    cardActivity: {
      width: '286px',
      height: '390px',
    },
    cardQuick: {
      width: '180px',
      height: '160px',
    },
    cardRide: {
      imageWidth: '213px',
      imageHeight: '220px',
    },

    // Image sizes
    logoCircle: {
      width: '159px',
      height: '159px',
    },
    logoSidebar: {
      width: '72px',
      height: '24px',
    },

    // Button sizes
    iconButton: {
      width: '40px',
      height: '40px',
    },
    durationBadgeNumber: {
      width: '26px',
    },

    // Sidebar
    sidebar: {
      width: '106px',
    },

    // Icons
    icon: {
      xs: '16px',
      sm: '20px',
      md: '24px',
      lg: '32px',
    },

    // Chat components
    feedbackButton: {
      width: '44px',
      height: '36px',
    },
    activityCardImage: {
      height: '120px',
    },
    suggestedItem: {
      height: '40px',
    },
    placeOverlayImage: {
      large: '382px',
      medium: '187px',
      small: '200px',
      food: '191px',
      thumbnail: '66px',
      thumbnailHeight: '60px',
    },
  },

  // Gaps (specific non-standard gaps)
  gaps: {
    greeting: '43px', // Hero section greeting to search
    sectionContent: '42px', // Between left and right content
    divider: '13px', // Suggested searches divider
  },
} as const;

export type DimensionToken = typeof dimensions;
